export default function tr(en, ja, lang) {
  if (lang === 'ja') {
    return ja;
  } else {
    return en;
  }
}
